
interface IProps {
    title: string;
    content: React.ReactNode;
    styles?: { row?: React.CSSProperties, title?: React.CSSProperties, content?: React.CSSProperties }
}
const InlineContent = ({ title, content, styles: propsStyles }: IProps) => {
    const styles: { row?: React.CSSProperties, title?: React.CSSProperties, content?: React.CSSProperties } = {
        row: { display: 'flex', alignItems: 'center', ...propsStyles?.row },
        title: { flex: '1', fontWeight: 700, ...propsStyles?.title },
        content: { flex: '6', ...propsStyles?.content }
    };

    return <>
        <div style={styles.row}>
            <div style={styles.title}>{title}</div>
            <div style={styles.content}>{content}</div>
        </div>
    </>
};



export { InlineContent }